// 개인정보 처리방침 콘텐츠
export const privacyPolicyContent = {
  title: '개인정보 처리방침',
  lastUpdated: '2026년 6월 22일',
  sections: [
    {
      heading: '1. 개인정보의 수집 및 이용 목적',
      body: '손안의 교회(이하 "서비스")는 다음의 목적을 위해 개인정보를 처리합니다.\n\n• 회원 가입 및 관리: 회원 식별, 가입 의사 확인, 서비스 부정이용 방지\n• 서비스 제공: 게시물 작성·열람, 댓글, 좋아요 등 커뮤니티 기능 제공\n• 알림 발송: 새 게시글, 댓글, 좋아요 등 푸시 알림 제공\n• 서비스 개선: 이용 통계 분석, 서비스 품질 향상',
    },
    {
      heading: '2. 수집하는 개인정보 항목',
      body: '서비스는 소셜 로그인(Google, Kakao, Naver)을 통해 다음 정보를 수집합니다.\n\n• 필수 항목: 이메일 주소, 이름(닉네임), 프로필 사진, 소셜 계정 고유 식별자\n• 서비스 이용 과정에서 생성되는 정보: 게시글, 댓글, 사진, 기기 정보(푸시 토큰)',
    },
    {
      heading: '3. 개인정보의 보유 및 이용 기간',
      body: '회원의 개인정보는 서비스 이용 기간 동안 보유하며, 회원 탈퇴 시 지체 없이 파기합니다.\n\n다만, 관련 법령에 따라 보존이 필요한 경우 해당 기간 동안 보관합니다.\n• 전자상거래 등에서의 소비자 보호에 관한 법률: 계약 또는 청약철회 등에 관한 기록 5년\n• 통신비밀보호법: 로그인 기록 3개월',
    },
    {
      heading: '4. 개인정보의 제3자 제공',
      body: '서비스는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다.\n\n다만, 다음의 경우에는 예외로 합니다.\n• 이용자가 사전에 동의한 경우\n• 법령의 규정에 의거하거나 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우',
    },
    {
      heading: '5. 개인정보의 파기 절차 및 방법',
      body: '서비스는 개인정보 보유 기간의 경과, 처리 목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.\n\n• 전자적 파일: 복구 불가능한 방법으로 영구 삭제\n• 종이 문서: 분쇄기로 분쇄하거나 소각',
    },
    {
      heading: '6. 개인정보의 안전성 확보 조치',
      body: '서비스는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.\n\n• 개인정보의 암호화: 비밀번호 등 중요 정보는 암호화하여 저장·관리\n• 접근 권한 관리: 개인정보에 대한 접근 권한을 최소한의 인원으로 제한\n• SSL/TLS 통신: 네트워크를 통한 개인정보 전송 시 암호화 통신 사용',
    },
    {
      heading: '7. 이용자의 권리와 행사 방법',
      body: '이용자는 언제든지 다음의 권리를 행사할 수 있습니다.\n\n• 개인정보 열람 요구\n• 개인정보 수정 요구\n• 개인정보 삭제 요구 (회원 탈퇴)\n• 개인정보 처리 정지 요구\n\n위 권리 행사는 앱 내 마이페이지 또는 개인정보 보호책임자에게 연락하여 가능합니다.',
    },
    {
      heading: '8. 게시물 및 미디어 관리',
      body: '이용자가 업로드한 게시물, 사진 등의 미디어 파일은 AWS 클라우드 서버에 안전하게 저장됩니다.\n\n• 게시물 삭제 시 관련 미디어 파일도 함께 삭제됩니다.\n• 회원 탈퇴 시 작성한 게시물 및 미디어는 삭제 처리됩니다.',
    },
    {
      heading: '9. 부적절한 콘텐츠 신고 및 처리',
      body: '서비스는 건전한 커뮤니티 환경을 위해 부적절한 콘텐츠 신고 기능을 제공합니다.\n\n• 이용자는 부적절한 게시물 또는 댓글을 신고할 수 있습니다.\n• 신고된 콘텐츠는 관리자가 검토 후 삭제 또는 비공개 처리할 수 있습니다.\n• 반복적으로 부적절한 콘텐츠를 게시하는 이용자는 이용이 제한될 수 있습니다.',
    },
    {
      heading: '10. 개인정보 보호책임자',
      body: '서비스의 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 이용자의 불만 처리 및 피해 구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.\n\n• 개인정보 보호책임자: 주님의 교회 관리자\n• 연락처: 앱 내 문의 기능 이용',
    },
    {
      heading: '11. 개인정보 처리방침의 변경',
      body: '이 개인정보 처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경 내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.',
    },
  ],
};
